import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HttpService } from '@services/http.service';
import { CreateUser } from '@models/create-user.model';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends HttpService {
  apiUrl = `${environment.apiUrl}/users/`;

  register(user: CreateUser): Observable<any> {
    return this.post(this.apiUrl, user);
  }

  getCurrentUser(): Observable<any> {
    const userId = this.storageService.get('userId');
    const options = this.createOptions();

    return this.get(this.apiUrl + userId, options);
  }

  getSessionUser(): Observable<any> {
    const options = this.createOptions();

    return this.get(this.apiUrl + 'session', options);
  }

  updateCurrentUser(updatedUserData): Observable<any> {
    const options = this.createOptions();
    return this.put(this.apiUrl, updatedUserData, options);
  }

  recovery(email: string): Observable<any> {
    const options = this.createOptions();

    return this.post(this.apiUrl + 'recovery-password/?email=' + email, options);
  }

  recoveryPassword(tokenId: string, token: string, password: string): Observable<any> {
    const options = this.createOptions();
    return this.post(this.apiUrl + 'recovery-password/change', {
      'tokenId': tokenId,
      'token': token,
      'password': password
    }, options);
  }

  dismissNotification(notificationId: string): Observable<any> {
    const options = this.createOptions();
    return this.delete(this.apiUrl + 'notifications/' + notificationId, options)
  }

  private createOptions() {
    const token = this.storageService.get('tok');

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      })
    };

    return options;
  }

  getUserLoginLogs(userId: string): Observable<any> {
    const options = this.createOptions();
    return this.get(`${this.apiUrl}login-log/${userId}`, options);
  }

  verifyEmail(tokenId: string, token: string) {
    return this.http.post<void>(`${environment.apiUrl}/users/verify-email`, {
      tokenId,
      token,
    });
  }

  resendVerification(email: string) {
    return this.http.post<void>(
      `${environment.apiUrl}/users/resend-verification`,
      { email }
    );
  }


}
